<template>
	<component :is="tagName" v-html="sanitizedHtml" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { sanitizeHtml, sanitizeSvg } from '../utils/sanitizeHtml';

type SafeHtmlTag =
	| 'div'
	| 'span'
	| 'p'
	| 'strong'
	| 'em'
	| 'small'
	| 'label'
	| 'h1'
	| 'h2'
	| 'h3'
	| 'h4'
	| 'h5'
	| 'h6';

const safeTags = new Set<string>([
	'div',
	'span',
	'p',
	'strong',
	'em',
	'small',
	'label',
	'h1',
	'h2',
	'h3',
	'h4',
	'h5',
	'h6',
]);

const props = withDefaults(
	defineProps<{
		html?: string | number | null;
		tag?: SafeHtmlTag;
		profile?: 'html' | 'svg';
	}>(),
	{
		html: '',
		tag: 'div',
		profile: 'html',
	}
);

const tagName = computed(() => (safeTags.has(props.tag) ? props.tag : 'div'));
const sanitizedHtml = computed(() =>
	props.profile === 'svg' ? sanitizeSvg(props.html) : sanitizeHtml(props.html)
);
</script>
